export default __webpack_public_path__ + "2045113a44d953d7aa49f9bc076f18b0.png";